/* @flow */
// typecheck: ignore file
import React from 'react';
import cx from 'classnames';
import TopicsSectionTitle from 'groups/components/TopicsSectionTitle.jsx';

type Props = {
  title?: string,
  className?: string,
  children?: React$Element<*>,
}

const Section = (props: Props) => {
  return (
    <section className={cx('GroupsNav-section', props.className)}>
      {props.title &&
        <TopicsSectionTitle className="GroupsNav-section-title">
          {props.title}
        </TopicsSectionTitle>
      }
      {props.children}
    </section>
  );
};

export default Section;



// WEBPACK FOOTER //
// ./src/groups/components/GroupsNav-Section.js